import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const Box = styled.div`
  padding-bottom: 200px;

  .list {
    ${mixin.flex({ justify: 'flex-start', wrap: 'wrap', align: 'flex-start' })};
    gap: 36px 1px;

    .item {
      width: calc(50% - 0.5px);
    }
  }

  .thum {
    padding-bottom: 133.1550802139037%;
  }

  .text03,
  .text02,
  .text01 {
    width: 154px;
    height: 20px;
    border-radius: 4px;
    margin: 8px 0 0 8px;
  }

  .text02 {
    margin-top: 4px;
  }

  .text03 {
    width: 80px;
    margin-top: 4px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding-bottom: ${mixin.pxToVw('200')};

    .list {
      gap: ${mixin.pxToVw('36 1')};
    }

    .text03,
    .text02,
    .text01 {
      width: ${mixin.pxToVw('154')};
      height: ${mixin.pxToVw('20')};
      border-radius: ${mixin.pxToVw('4')};
      margin: ${mixin.pxToVw('8 0 0 8')};
    }

    .text02 {
      margin-top: ${mixin.pxToVw('4')};
    }

    .text03 {
      width: ${mixin.pxToVw('80')};
      margin-top: ${mixin.pxToVw('4')};
    }
  }
`;
